import Chart from 'chart.js/auto';
import { watchChartTypography } from './app/shared/services/chart-typography';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { watchAppUpdates } from './app-update';

if (environment.production) {
  enableProdMode(); 
}


watchChartTypography(Chart);
watchAppUpdates(environment.production);
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));  
